<template>
  <vs-popup
    id="rawMaterialUpdateQueueModal"
    :active.sync="rawMaterialUpdateQueueActive"
    v-esc="escape"
    title="Hammadde Güncelleme Kuyruğu"
  >
    <vs-table ref="table" :data="updateQueue" :max-items="12">

      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter ref="filterer" :tableOptions="tableOptions" :filterOptions="filterOptions"
                         :filterChips="filterChips" :filterOptionNames="filterOptionNames" :isActive="isFilterActive"
                         @saveOptions="saveOptions" @close="isFilterActive = false;"/>
          <vs-row id="panelHeaderRow" v-show="!isFilterActive" vs-type="flex" vs-w="12" vs-justify="space-between">
            <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="center">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button @click="isFilterActive = !isFilterActive;"
                               class="panel-action text-warning xlarge-button panel-action-box-shadow"
                               color="transparent"
                               icon-pack="pickicon" icon="icon-pick-filter">
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip title="Yenile" :text="toRefreshString + ' içinde yenilenecek.'" position="top">
                    <vs-button @click="refreshNow()"
                               class="panel-action text-primary xlarge-button panel-action-box-shadow" color="transparent"
                               icon-pack="feather" icon="icon-refresh-ccw">
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
                <vs-button id="clearFilterButton" v-if="filterChips.length > 0" @click="clearFilter"
                           class="mr-2 bg-white text-danger panel-action-box-shadow" icon-pack="feather"
                           icon="icon-slash" radius
                           color="transparent"/>
                <vs-col vs-type="flex" class="w-auto" v-for="(chip,index) in filterChips" :key="index">
                  <vs-chip color="white" class="panel-action-box-shadow px-1" @click="removeFilter(chip.col,index)"
                           v-show="chip.value != '' " closable>
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + ' :' }}
                        </span>
                      </vs-col>
                      <vs-col vs-type="flex" class="w-auto ml-1" vs-align="center">
                        <span class="weight-600 italic text-xsmaller text-primary">
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="table-page-size" vs-type="flex" class="w-auto" vs-justify="flex-end">

            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">

        <vs-th>
          <vs-button color="primary" type="flat">Id
          </vs-button>
        </vs-th>
        <vs-th>
          <vs-button color="primary" type="flat">Tarih
          </vs-button>
        </vs-th>
        <vs-th>
          <vs-button color="primary" type="flat">Hammadde
          </vs-button>
        </vs-th>
        <vs-th>
          <vs-button color="primary" type="flat">Durum
          </vs-button>
        </vs-th>
        <vs-th>
          <vs-button color="primary" class="opacity-full" disabled="true" type="flat">İşlem</vs-button>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="font-medium truncate">{{ tr.id }}</p>
          </vs-td>

          <vs-td>
            <p class="font-medium truncate">{{tr.created}}</p>
          </vs-td>

          <vs-td>
            <p class="font-medium truncate">{{ tr.rawMaterialName }}({{tr.rawMaterialSku}})</p>
          </vs-td>

          <vs-td>
            <p class="font-medium truncate">{{ getStatusName(tr.status) }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
              <vs-col v-if="tr.status == 2 || tr.status == 3" vs-type="flex" vs-w="6" class="pr-1" vs-justify="center" vs-align="center">
                <vx-tooltip color="danger" class="mr-2" title="İptal Et">
                  <vs-button @click="cancelUpdate(tr)"
                             color="danger"
                             icon-pack="feather" icon="icon-trash">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col v-if="tr.status == 0 || tr.status == 1" vs-type="flex" vs-w="6" class="pl-1" vs-justify="center" vs-align="center">
                <vx-tooltip color="warning" title="Tekrar Dene">
                  <vs-button @click="tryAgainUpdate(tr)"
                             class="text-light"
                             color="warning"
                             icon-pack="feather" icon="icon-refresh-ccw">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              <vs-col v-if="tr.status == 4" vs-type="flex" vs-w="6" vs-justify="center" vs-align="center">
                <feather-icon icon="CheckIcon" svgClasses="w-4 h-4 text-success" />
              </vs-col>
              <vs-col v-else-if="tr.status == 5" vs-type="flex" vs-w="6" vs-justify="center" vs-align="center">
                <feather-icon icon="XIcon" svgClasses="w-4 h-4 text-danger" />
              </vs-col>
            </vs-row>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <pagination-default :totalLenght="calculatePageLength" :setCurrentPage="tableOptions.pageIndex"
                        @currentPage="getCurrentPage"></pagination-default>
  </vs-popup>
</template>

<script>
import {getQueue, tryAgainUpdate, cancelUpdate} from "@/api/RawMaterialUpdateQueue"
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault"
export default {
  name: "RawMaterialUpdateQueueModal",
  data() {
    return {
      rawMaterialUpdateQueueActive: false,
      tableOptions: {
        pageIndex: 0
      },
      currentPage: 0,
      isFilterActive: false,
      filterOptions: ["queueStatus", "rawMaterial"],
      filterOptionNames: ["Durum", "Hammadde"],
      filterChips: [],
      updateQueue: [],
      totalDataRow: 0,
      toRefresh: 5 * 60
    }
  },
  components: {
    GlobalFilter,
    PaginationDefault
  },
  methods: {
    getStatusName(status) {
      switch (status) {
        case 0:
          return 'Hata !';
        case 1:
          return 'İptal Edildi';
        case 2:
          return 'Kuyrukta';
        case 3:
          return 'Güncelleniyor';
        case 4:
          return 'Tamamlandı';
        case 5:
          return 'İptal Ediliyor';
      }
    },
    refreshNow() {
      this.toRefresh = 5 * 60;
      this.getQueue()
    },
    doRefresh() {
      let vm = this;
      setInterval(function () {
        vm.toRefresh--;
      }, 1000);
    },
    escape() {
      if (this.rawMaterialUpdateQueueActive) {
        this.rawMaterialUpdateQueueActive = false;
      }
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        pageIndex: 0,
        rawMaterial: null,
        status: null
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getQueue() {
      getQueue(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          this.updateQueue = res.data.items;
          this.totalDataRow = res.data.totalCount;
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Güncelleme Kuyruğu Getirilemedi !'
          });
        }
      })
    },
    cancelUpdate(queueItem) {
      cancelUpdate(queueItem.id).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: 'success',
            title: 'İptal İşlemi',
            text: 'Güncelleme İptal Edildi !'
          });
          this.getQueue();
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'İptal İşlemi Başarısız !'
          });
        }
      })
    },
    tryAgainUpdate(queueItem) {
      tryAgainUpdate(queueItem.id).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: 'success',
            title: 'Yeniden Deneme İşlemi',
            text: 'Güncelleme Tekrar İşleme Alındı !'
          });
          this.getQueue();
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Tekrar Deneme İşlemi Başarısız !'
          });
        }
      })
    }
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % 12;
      return (mod > 0) ? ((this.totalDataRow - mod) / 12) + 1 : this.totalDataRow / 12;
    },
    toRefreshString() {
      if (this.toRefresh < 60) return this.toRefresh + " Saniye";
      if (this.toRefresh == 60) return "1 Dakika";
      let min = this.toRefresh / 60;
      let sec = this.toRefresh % 60;
      return (min | 0) + " Dakika " + sec + " Saniye";
    },
  },
  mounted() {
    this.clearFilter();
    this.doRefresh();
  },
  watch: {
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getQueue();
        });
      }
    },
  }
}
</script>

<style>
#rawMaterialUpdateQueueModal .vs-popup {
  background-color: rgb(248, 248, 248) !important;
  width: 70vw;
}

</style>
